module.exports = __webpack_public_path__ + "media/bootstrap-icons/archive-c991de12.svg";